<template>
  <div class="booking-widget"
    :class="{'error': !!errors.has(newName)}"
  >

    <!-- data-vv-scope="booking-widget-form" -->
    <functional-calendar
      :configs="calendarConfigs"
      name="date_range"
      ref="BookingCalendar"
      v-model="model"
    >
      <template v-slot:dateRangeInputs="props">
        <h2 class="section-title-sm mb-3">{{ title }}</h2>

        <div class="grid grid-cols-2 gap-2">
          <div>
            <label class="theme-input__label" for="check-in">From</label>
            <div class="booking-widget__input-wrapper">
              <input
                id="check-in"
                class="booking-widget__input"
                :class="{'bg-red-500': !!errors.has(newName)}"
                type="text"
                title="Start Date"
                name="start_date"
                :value="
                  props.startDate
                    ? moment(props.startDate, 'DD/MM/YYYY').format('DD-MM-YYYY')
                    : null
                "
                :placeholder="chooseDatePlaceholder"
                :readonly="!props.isTypeable"
                v-validate="`required`"
                />
              <div class='theme-input__extra-info'>
                <span class="icon-calendar"/>
              </div>
              <input
                type="hidden"
                name="start_date"
                :value="moment(props.startDate, 'DD/MM/YYYY').format('YYYY-MM-DD')"
              />
            </div>
            <div class="theme-input__error-text" v-if="errors.has(newName)">
              {{ errors.first(newName) }}
            </div>
          </div>

          <div>
            <label class="theme-input__label" for="check-in">To</label>
            <div class="booking-widget__input-wrapper">
              <input
                id="check-out"
                class="booking-widget__input"
                name="end_date"
                type="text"
                title="End Date"
                :value="
                  props.endDate
                    ? moment(props.endDate, 'DD/MM/YYYY').format('DD-MM-YYYY')
                    : null
                "
                :placeholder="chooseDatePlaceholder"
                :readonly="!props.isTypeable"
                v-validate="`required`"
                />
                <!-- valid-scope="booking-widget-form" -->
              <div class='theme-input__extra-info'>
                <span class="icon-calendar"/>
              </div>
              <input
                type="hidden"
                name="end_date"
                :value="moment(props.endDate, 'DD/MM/YYYY').format('YYYY-MM-DD')"
              />
            </div>
          </div>

        </div>
      </template>
    </functional-calendar>

    <theme-multiple-files
      accept="application/pdf, image/*"
      name="document[]"
      :id="id"
      ref="themeFileInput"
      :white="true"
    ></theme-multiple-files>

    <div class="progress" v-if="showLoader">
      <div class="progress-bar"></div>
    </div>

    <template
      v-if="
        model && model.dateRange && model.dateRange.start && model.dateRange.end
      "
    >
      <div class="booking-widget__summary-list">
        <p class="">
          {{
            moment(model.dateRange.end, "DD/MM/YYYY").diff(
              moment(model.dateRange.start, "DD/MM/YYYY"),
              "days"
            ) + 1
          }}
          {{ locales && locales.common && locales.common.days }}
        </p>
        <div class="booking-widget__summary-item">
          <span
            >{{
              locales && locales.properties && locales.properties.price
            }}:</span
          >
          <span class="booking-widget__summary-price">€ {{ bookPrice.toFixed(2) }}</span>
        </div>
        <div class="booking-widget__summary-item"
          v-for="(item, index) in extraPrices"
          :key="index"
        >
          <span>{{ item.name }}:</span>
          <span class="booking-widget__summary-price"
            >€ {{ getPeriodPrice(item.price, "month").toFixed(2) }}</span
          >
        </div>
        <div class="booking-widget__summary-item">
          <strong>{{ locales && locales.common && locales.common.total }}:</strong>
          <strong class="booking-widget__summary-price">€ {{ total.toFixed(2) }}</strong>
        </div>
      </div>
    </template>

    <button v-if="isLogged" data-type="submitBtn" class="theme-btn theme-btn--block theme-btn--primary" @click.prevent="submitForm">{{ buttonName }}</button>
    <a v-else class="theme-btn theme-btn--block theme-btn--primary" data-feature="open-modal" data-target="login">
        {{ buttonName }}
    </a>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import _ from "lodash";
import $ from "jquery";
import { FunctionalCalendar } from "vue-functional-calendar";
import ThemeDownload from "./ThemeDownload.vue";
import field from '../admin/mixins/field'

export default {
  $_veeValidate: {
    validator: "new",
  },
  mixins: [field],
  components: { FunctionalCalendar, ThemeDownload },
  computed: {
    ...mapGetters(["locales"]),
    bookPrice: function () {
      var start = new Date(
        moment(this.model.dateRange.start, "DD/MM/YYYY").format("YYYY-MM-DD")
      );
      var end = new Date(
        moment(this.model.dateRange.end, "DD/MM/YYYY").format("YYYY-MM-DD")
      );
      var periodPrice = 0;
      if (this.model.dateRange.start && this.model.dateRange.end) {
        var period = this.countPeriod(this.period, start, end);
        var price = parseFloat((this.periodPrice + "").replace(",", "."));
        periodPrice = Math.round(price * period * 100) / 100;
      }
      return periodPrice;
    },
    total: function () {
      var t = 0;
      t += this.bookPrice;
      for (const [key, item] of Object.entries(this.extraPrices)) {
        let itemPrice = this.getPeriodPrice(item.price, "month");
        t += itemPrice;
      }
      t = Math.round(t * 100) / 100;
      return t;
    },
  },
  data() {
    return {
      model: this.range,
      minDate: new Date(),
      showLoader: false,
      calendarConfigs: {
        dateFormat: "dd/mm/yyyy",
        limits: {
          min: moment().format("DD/MM/YYYY"),
          max: moment().add("10", "y").format("DD/MM/YYYY"),
        },
        markedDates: this.disabledDates,
        disabledDates: this.disabledDates,
        isDateRange: true,
        isModal: true,
        minSelDays: this.minDays,
        maxSelDays: this.maxDays,
        isAutoCloseable: true,
        isMultiple: true,
        calendarsCount: 2,
        monthNames: this.months,
        dayNames: this.days,
      },
    };
  },
  props: {
    selectedDate: {
      default: null,
      type: String,
    },
    range: {
      default: {},
      type: Object,
    },
    disabledDates: {
      default: [],
      type: Array,
    },
    period: {
      default: "day",
      type: String,
    },
    periodPrice: {
      default: "",
      type: String,
    },
    extraPrices: {
      default: [],
      type: [Array, Object],
    },
    months: {
      default: [],
      type: [Array, Object],
    },
    days: {
      default: [],
      type: [Array, Object],
    },
    minDays: {
      default: false,
      type: [Number, Boolean],
    },
    maxDays: {
      default: false,
      type: [Number, Boolean],
    },
    buttonName: {
      default: "",
      type: String,
    },
    title: {
      default: "",
      type: String,
    },
    isLogged: {
      default: false,
      type: Boolean,
    },
    submitFn: {
      default: () => 1,
      type: Function,
    },
    fnParams: {
      default: () => [],
      type: [Array, Object],
    },
    chooseDatePlaceholder: {
      default: 'Choose date',
      type: String,
    },
    id: {
      default: '',
      type: String,
    },
  },
  methods: {
    submitForm: async function (e) {
     await this.submitFn(e, ...this.fnParams);
    },
    moment: function (date = null, format = null) {
      return moment(date, format);
    },
    countPeriod(period, startDate, endDate) {
      var diff = 0;
      if (period == "week") {
        let week = 24 * 60 * 60 * 1000 * 7; // hours*minutes*seconds*milliseconds
        let day = 24 * 60 * 60 * 1000;
        diff = Math.abs((startDate - endDate - day) / week);
      } else if (period == "day") {
        let day = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        diff = Math.ceil(Math.abs((startDate - endDate) / day)) + 1;
      } else if (period == "month") {
        var substract = 0;
        var monthPart = 0;
        if (startDate.getDate() > 1) {
          substract += 1;
          var lastDayOfMonth = new Date(
            startDate.getFullYear(),
            startDate.getMonth() + 1,
            0
          );
          monthPart +=
            (lastDayOfMonth.getDate() - startDate.getDate() + 1) /
            lastDayOfMonth.getDate();
        }
        var lastDayOfEndMonth = new Date(
          endDate.getFullYear(),
          endDate.getMonth() + 1,
          0
        );
        if (endDate.getDate() < lastDayOfEndMonth.getDate()) {
          substract += 1;
          monthPart += endDate.getDate() / lastDayOfEndMonth.getDate();
        }
        let startMonth = startDate.getMonth() + 1;
        let endMonth = endDate.getMonth() + 1;
        let startYear = startDate.getFullYear();
        let endYear = endDate.getFullYear();
        if (startYear < endYear) {
          endMonth += (endYear - startYear) * 12;
        }
        if (endMonth - startMonth + 1 > 0) {
          diff = endMonth - startMonth + 1 - substract + monthPart;
        } else {
          diff = monthPart;
        }
      }
      return diff;
    },
    getPeriodPrice(price, periodType) {
      var start = new Date(
        moment(this.model.dateRange.start, "DD/MM/YYYY").format("YYYY-MM-DD")
      );
      var end = new Date(
        moment(this.model.dateRange.end, "DD/MM/YYYY").format("YYYY-MM-DD")
      );
      var period = this.countPeriod(periodType, start, end);
      let p =
        Math.round(parseFloat((price + "").replace(",", ".")) * period * 100) /
        100;
      return p;
    },
    clearForm() {
      this.model.dateRange.start = '';
      this.model.dateRange.end = '';
      document.querySelectorAll('[name="document"]').forEach((input) => {
        this.$refs.themeFileInput.clearInput();
      });
    },
  },
  created() {
    this.$root.$on("uploading-started", () => {
      this.showLoader = true;
    });
    this.$root.$on("uploading-completed", () => {
      this.showLoader = false;
    });
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/components/BookingWidget.vue